import { ROUTES } from '@configs/AppRoutes';

export const BREADCRUMBS_LABELS = {
    TEMPLATES: [
        { label: 'Bill of Materials', link: ROUTES.BOM },
        { label: 'Templates' },
    ],
    TEMPLATE_INFO: (slug: string) => [
        { label: 'Bill of Materials', link: ROUTES.BOM },
        { label: 'Templates', link: ROUTES.TEMPLATES },
        { label: `${slug}` },
    ],

    CREATE_NEW_PROJECT: [
        { label: 'Bill of Materials', link: ROUTES.BOM },
        { label: 'Create new project' },
    ],
};
